import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { SlideDown } from 'react-slidedown';
import { Split } from 'styles/common';
import 'react-slidedown/lib/slidedown.css';
import dateFns from 'date-fns';
import moment from 'moment';
import Logo from 'assets/orca-logo-black-min.png';
import { isImperial } from 'services/Units/thunks';
import {
    ReportGeneratorContainer,
    DrivingReportGenerator,
    InputLabel,
    Report,
} from 'styles/reports';
import { Dashboard } from 'styles/dashboard';
import Error from 'components/Error';

import { Alert } from 'react-bootstrap';
import ReportsInputDate from 'components/ReportsInputDate';

import ReportDataTable from 'containers/ReportDataTableMaintenance';
import { OUTPUT_FORMATS, PRESET_PERIODS } from 'services/Report/constants';
import SelectField from 'components/SelectField';
import colors from 'styles/colors';
import MagnifyingGlass from 'assets/search-icon-white.svg';
import ReportIcon from 'assets/report-pen.svg';
import Calendar from 'assets/calendar-black.svg';
import Bugs from 'assets/bug.svg';
import { selectorsGetCurrentUser } from 'services/CurrentUser/selectors';

import {
    validateMaintenanceReportGenerator,
    generateMaintenanceReport,
    removeMaintenanceReportError,
    resetMaintenanceReport,
} from 'services/Report/thunks';
import { selectVehicles } from 'services/Vehicle/selectors';

import { Excel } from 'antd-table-saveas-excel';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import {
    selectMaintenanceReportGenerationErrors,
    selectIsLoading,
    selectMaintenanceReport,
} from 'services/Report/selectors';
import { thunksGetCurrentUser } from 'services/CurrentUser/thunks';

import GenerateReportHeader from 'containers/ReportGenerator/Header';
import ReportVehicleSearch from 'components/ReportVehicleSearch';
import Loader from 'components/Loader';

const today = dateFns.format(new Date(), 'YYYY-MM-DD');
let exportData = [];
const ReportPageComponent = (props) => {
    const [reportGeneratedFilterOpen, setReportGeneratedFilterOpen] = useState(false);
    const [equipmentIds, setEquipmentIds] = useState([]);
    const [period, setPeriod] = useState(PRESET_PERIODS.custom);
    const [format, setFormat] = useState(OUTPUT_FORMATS.page);
    const [periodFrom, setPeriodFrom] = useState(today);
    const [periodTo, setPeriodTo] = useState(today);
    const [dateLimit, setDateLimit] = useState(false);
    const [dateLimitPositionLeft, setDateLimitPositionLeft] = useState(true);
    const {
        resetMaintenanceReport,
        validateMaintenanceReportGenerator,
        generateMaintenanceReport,
        intl,
        loading,
        report,
    } = props;
    useEffect(() => {
        props.thunksGetCurrentUser();
    }, []);
    useEffect(
        () => {
            resetMaintenanceReport();
        },
        [resetMaintenanceReport]
    );
    useEffect(
        () => {
            if (!props.report) return;

            if (format === 'pdf') {
                handleOnExportPDF();
            } else if (format === 'xlsx') {
                handleOnExportXLS();
            }
        },
        [props.report]
    );

    const handleOnChangePeriod = (key: string) => (event: Event) => {
        changePeriod(key, event.target.value);
        props.removeMaintenanceReportError(key);
    };
    const changePeriod = (key: string, date: string) => {
        if (dateLimit) {
            setDateLimit(false);
        }
        if (key === 'periodFrom' && dateFns.differenceInDays(periodTo, date) > 366) {
            const newDateTo = dateFns.addDays(date, 366);
            const formattedNewDate = dateFns.format(newDateTo, 'YYYY-MM-DD');
            setDateLimit(true);
            setPeriodTo(formattedNewDate);
            setDateLimitPositionLeft(true);
        } else if (key === 'periodTo' && dateFns.differenceInDays(date, periodFrom) > 366) {
            const newDateFrom = dateFns.subDays(date, 366);
            const formattedNewDateFrom = dateFns.format(newDateFrom, 'YYYY-MM-DD');
            setDateLimit(true);
            setPeriodFrom(formattedNewDateFrom);
            setDateLimitPositionLeft(false);
        }
        let dateToChange = date;
        const dateCompare =
            key == 'periodFrom'
                ? dateFns.compareAsc(date, periodTo)
                : dateFns.compareAsc(periodFrom, date);
        const todayCompare = dateFns.compareAsc(date, today);
        if (todayCompare === 1) {
            dateToChange = today;
        }
        if (dateCompare === 1) {
            if (key == 'periodTo') {
                setPeriodFrom(dateToChange);
            } else {
                setPeriodTo(dateToChange);
            }
        }
        if (key == 'periodFrom') {
            setPeriodFrom(dateToChange);
            setPeriod(PRESET_PERIODS.custom);
        } else {
            setPeriodTo(dateToChange);
            setPeriod(PRESET_PERIODS.custom);
        }
    };
    const onChangeSelect = (key: string) => (value: string) => {
        if (key === 'format') {
            setFormat(value);
        }
    };
    const getColumns = () => {
        const columns = [
            {
                title: props.intl.formatMessage({
                    id: 'components.Modals.Form.Config.CustomIcon.Vehicle',
                }),
                dataIndex: 'type',
                key: 'type',
            },
            {
                title: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.date',
                }),
                dataIndex: 'Date',
                key: 'Date',
            },
            {
                title: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.invoiceNumber',
                }),
                dataIndex: 'NumeroDeFacture',
                key: 'NumeroDeFacture',
            },
            {
                title: `${props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.cost',
                })} `,
                dataIndex: 'Cout',
                key: 'Cout',
            },
            {
                title: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.vehicleTypes',
                }),
                dataIndex: 'TypeVehicule',
                key: 'TypeVehicule',
            },
            {
                title: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.entryDate',
                }),
                dataIndex: 'DateEntree',
                key: 'DateEntree',
            },
            {
                title: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.exitDate',
                }),
                dataIndex: 'DateSortie',
                key: 'DateSortie',
            },
            {
                title: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.technician',
                }),
                dataIndex: 'technicianName',
                key: 'technicianName',
            },
            {
                title: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.repairType',
                }),
                dataIndex: 'TypeReparation',
                key: 'TypeReparation',
            },
            {
                title: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.department',
                }),
                dataIndex: 'Departement',
                key: 'Departement',
            },
            {
                title: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.garage',
                }),
                dataIndex: 'Garage',
                key: 'Garage',
            },
            {
                title: props.isImperial()
                    ? props.intl.formatMessage({
                          id: 'containers.Maintenance.VehicleDetails.Miles',
                      })
                    : props.intl.formatMessage({
                          id: 'containers.Maintenance.VehicleDetail.VehiculeOdometer',
                      }),
                dataIndex: 'Odometre',
                key: 'Odometre',
            },
            {
                title: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.hourmeter',
                }),
                dataIndex: 'Horometre',
                key: 'Horometre',
            },
            {
                title: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.comments',
                }),
                dataIndex: 'EntretienCommentaire',
                key: 'EntretienCommentaire',
            },
        ];

        return columns;
    };

    const handleExportReport = () => {
        exportData = [];
        const { report } = props;
        let vehicleName;
        let odometer;
        let horometer;
        let numberOfMaintenance = 0;
        let totalCost = 0;
        let averageCost = 0;
        let totalAllMaintenanceNumber = 0;
        let totalAllMaintenanceCost = 0;
        let totalAllMaintenanceAverageCost = 0;
        const conversionFactor = props.isImperial() ? 1609.344 : 1000;

        const arrayData = Array.from(report);
        const sortedData = arrayData.sort((a, b) => {
            return a.get('vehiculeNumb').localeCompare(b.get('vehiculeNumb'));
        });

        sortedData.forEach((data, key) => {
            vehicleName = data.get('vehiculeNumb');
            data.get('data').forEach((list) => {
                numberOfMaintenance += 1;
                if (parseFloat(list.get('Cout'))) {
                    totalCost += parseFloat(list.get('Cout'));
                }
                horometer = list.get('Horometre')
                    ? parseFloat(list.get('Horometre')).toFixed(2) / 3600
                    : 0;
                odometer = list.get('Odometre')
                    ? (parseFloat(list.get('Odometre')) / conversionFactor).toFixed(2)
                    : 0;
                exportData.push({
                    type: vehicleName,
                    Date: dateFns.format(list.get('Date'), 'YYYY/MM/DD'),
                    NumeroDeFacture: list.get('NumeroDeFacture'),
                    Cout: list.get('Cout'),
                    TypeVehicule: list.get('TypeVehicule'),
                    DateEntree: dateFns.format(list.get('DateEntree'), 'YYYY/MM/DD'),
                    DateSortie: dateFns.format(list.get('DateSortie'), 'YYYY/MM/DD'),
                    technicianName: list.get('technicianName'),
                    TypeReparation: list.get('TypeReparation'),
                    Departement: list.get('Departement'),
                    Garage: list.get('Garage'),
                    Odometre: odometer,
                    Horometre: horometer,
                    EntretienCommentaire: list.get('EntretienCommentaire'),
                });
            });
            if (numberOfMaintenance > 0) {
                averageCost = totalCost / numberOfMaintenance;
            }
            exportData.push({
                type: `${vehicleName} \n ${props.intl.formatMessage({
                    id: 'containers.Reports.Move.total',
                })}`,
                Date: `${props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.maintenanceCount',
                })} :\n ${numberOfMaintenance}`,
                NumeroDeFacture: '',
                Cout: `${props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.totalCost',
                })} :\n ${totalCost.toFixed(2)}`,
                TypeVehicule: `${props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.averageCost',
                })} :\n ${averageCost.toFixed(2)}`,
                DateEntree: '',
                DateSortie: '',
                technicianName: '',
                TypeReparation: '',
                Departement: '',
                Garage: '',
                Odometre: '',
                Horometre: '',
                EntretienCommentaire: '',
            });
            totalAllMaintenanceNumber += numberOfMaintenance;
            if (totalCost > 0) {
                totalAllMaintenanceCost += totalCost;
            }
            if (totalAllMaintenanceNumber > 0) {
                totalAllMaintenanceAverageCost =
                    totalAllMaintenanceCost / totalAllMaintenanceNumber;
            }
            totalCost = 0;
            numberOfMaintenance = 0;
            averageCost = 0;
        });
        if (report.size > 1) {
            exportData.push({
                type: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.AllTotalMaintenace',
                }),
                Date: `${props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.maintenanceCount',
                })} :\n ${totalAllMaintenanceNumber}`,
                NumeroDeFacture: '',
                Cout: `${props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.totalCost',
                })} :\n ${totalAllMaintenanceCost.toFixed(2)}`,
                TypeVehicule: `${props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.averageCost',
                })} :\n ${totalAllMaintenanceAverageCost.toFixed(2)}`,
                DateEntree: '',
                DateSortie: '',
                technicianName: '',
                TypeReparation: '',
                Departement: '',
                Garage: '',
                Odometre: '',
                Horometre: '',
                EntretienCommentaire: '',
            });
        }
        if (props.loading) {
            if (props.loading) {
                return <Loader loading />;
            }
        }
    };
    const handleOnExportPDF = () => {
        const userEmail = props.getCurrentUser.email;
        const generateAt = props.intl
            .formatMessage({ id: 'components.Reports.move.pdf.generate' })
            .toString();
        const generateBy = `${props.intl.formatMessage({
            id: 'containers.Reports.Generators.By',
        })}`;

        const from = props.intl
            .formatMessage({ id: 'containers.Reports.Generators.From' })
            .toString();

        const to = props.intl.formatMessage({ id: 'containers.Reports.Generators.To' }).toString();

        const doc = new jsPDF('l');
        handleExportReport('pdf');

        doc.addImage(Logo, 'png', 12, 8);

        doc.setFont(undefined, 'bold');
        doc.text(
            `${props.intl.formatMessage({
                id: 'views.Maintenance.SideMenu.Report',
            })}`,
            143,
            27,
            { align: 'center' }
        );

        doc.setFontSize(9);
        doc.text(`${from} ${periodFrom} ${to} ${periodTo}`, 120, 32);

        doc.setFontSize(8);
        doc.text(generateAt + moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), 250, 10);
        doc.text(generateBy + `${userEmail}`, 230, 15);

        let pdf = exportData.map((data) => {
            if (data.horometer > 0) {
                data.horometer = data.horometer;
            }
            if (data.odometer > 0) {
                data.odometer = data.odometer;
            }
            return Object.values(data);
        });

        autoTable(doc, {
            headStyles: {
                textColor: 'white',
                fillColor: '#63AC37',
                fontSize: '8',
            },
            head: [getColumns()],
            bodyStyles: {
                textColor: 'black',
                fillColor: 'white',
                fontSize: '8',
            },
            body: pdf,
            startY: 58,
            theme: 'grid',
            margin: { top: 20 },
        });

        doc.save(
            `${props.intl.formatMessage({
                id: 'views.Maintenance.SideMenu.Report',
            })}.pdf`
        );
    };
    const handleOnExportXLS = () => {
        handleExportReport();
        let excelData = exportData;
        const excel = new Excel();
        excel
            .addSheet('MoveReport')
            .addColumns(getColumns())
            .addDataSource(excelData)
            .saveAs(
                `${props.intl.formatMessage({
                    id: 'views.Maintenance.SideMenu.Report',
                })}.xlsx`
            );
    };
    const handleGenerateReport = () => {
        const state = {
            equipmentIds,
            periodFrom,
            periodTo,
            dateLimit,
            dateLimitPositionLeft,
            period,
            reportGeneratedFilterOpen,
            format,
        };
        validateMaintenanceReportGenerator(state).then(() => {
            // submit generation form.
            exportData = [];
            const data = { ...state };
            data.format = 'display';
            generateMaintenanceReport(data);
            if (reportGeneratedFilterOpen) {
                setReportGeneratedFilterOpen(false);
            }
        });
    };
    const handleOnCheckVehicles = (id: number) => {
        const equipments = equipmentIds.slice();
        if (equipments.indexOf(id) >= 0) {
            equipments.splice(equipments.indexOf(id), 1);
        } else {
            equipments.push(id);
        }
        if (equipments.length > 0 && props.errors.get('equipmentIds')) {
            props.removeMaintenanceReportError('equipmentIds');
        }
        setEquipmentIds(equipments);
    };
    const handleOnSelectAllVehicles = (searchedEquipments) => {
        let equipments;
        if (searchedEquipments.toArray().length > 0) {
            equipments = searchedEquipments.map((equipment) => equipment.get('id')).toArray();
        } else {
            equipments = props.equipment
                .filter((eq) => {
                    if (eq.toJS().cardNumber) {
                        return !eq.toJS().cardNumber.startsWith('B');
                    } else {
                        return true;
                    }
                })
                .map((equipment) => equipment.get('id'))
                .toArray();
        }
        setEquipmentIds(equipments);
    };
    const handleOnUnselectAllVehicles = () => {
        const equipments = [];
        setEquipmentIds(equipments);
    };
    const handleSetPeriod = (presetPeriod: string) => () => {
        const currentDate = new Date();
        const periode = {};
        setDateLimit(false);
        switch (presetPeriod) {
            case PRESET_PERIODS.today: {
                periode.to = dateFns.startOfToday();
                periode.from = currentDate;
                break;
            }
            case PRESET_PERIODS.yesterday: {
                const yesterday = dateFns.subDays(currentDate, 1);
                periode.from = dateFns.startOfDay(yesterday);
                periode.to = dateFns.endOfDay(yesterday);
                break;
            }
            case PRESET_PERIODS.lastWeek: {
                const lastWeek = dateFns.subWeeks(currentDate, 1);
                periode.from = dateFns.startOfWeek(lastWeek);
                periode.to = dateFns.endOfWeek(lastWeek);
                break;
            }
            case PRESET_PERIODS.lastMonth: {
                const lastMonth = dateFns.subMonths(currentDate, 1);
                periode.from = dateFns.startOfMonth(lastMonth);
                periode.to = dateFns.endOfMonth(lastMonth);
                break;
            }
            case PRESET_PERIODS.thisMonth: {
                periode.from = dateFns.startOfMonth(currentDate);
                periode.to = dateFns.endOfMonth(currentDate);
                if (dateFns.compareAsc(today, periode.to) < 0) {
                    periode.to = today;
                }
                break;
            }
            case PRESET_PERIODS.thisWeek: {
                periode.from = dateFns.startOfWeek(currentDate);
                periode.to = dateFns.endOfWeek(currentDate);
                if (dateFns.compareAsc(today, periode.to) < 0) {
                    periode.to = today;
                }
                break;
            }
            default: {
                periode.from = '';
                periode.to = '';
            }
        }
        if (props.errors.get('periodFrom')) {
            props.removeMaintenanceReportError('periodFrom');
        }

        if (props.errors.get('periodTo')) {
            props.removeMaintenanceReportError('periodTo');
        }
        setPeriodTo(dateFns.format(periode.to, 'YYYY-MM-DD'));
        setPeriodFrom(dateFns.format(periode.from, 'YYYY-MM-DD'));
        setPeriod(presetPeriod);
    };
    const handleOnClickModifyReport = () => {
        setReportGeneratedFilterOpen(!reportGeneratedFilterOpen);
        exportData = [];
    };

    const renderGenerator = () => {
        if (loading) {
            return <Loader loading />;
        }
        return (
            <div>
                <DrivingReportGenerator>
                    <div className={'economieReport'}>
                        <ReportsInputDate
                            startDate={periodFrom}
                            onChangeStartDate={handleOnChangePeriod('periodFrom')}
                            errorsStartDate={props.errors.get('periodFrom')}
                            endDate={periodTo}
                            onChangeEndDate={handleOnChangePeriod('periodTo')}
                            errorEndDate={props.errors.get('periodTo')}
                            dateLimit={dateLimit}
                            dateLimitPositionLeft={dateLimitPositionLeft}
                        />

                        <DrivingReportGenerator.ColumnRep>
                            <InputLabel margin={'0 0 15px 0'}>
                                <FormattedMessage
                                    id={'containers.Reports.Generators.Driving.OutputFormat'}
                                />
                            </InputLabel>

                            <DrivingReportGenerator.SelectContainer>
                                <SelectField
                                    options={[
                                        {
                                            label: props.intl.formatMessage({
                                                id:
                                                    'containers.Reports.Generators.Driving.OutputFormat.Page',
                                            }),
                                            value: OUTPUT_FORMATS.page,
                                        },
                                        {
                                            label: props.intl.formatMessage({
                                                id:
                                                    'containers.Reports.Generators.Driving.OutputFormat.Pdf',
                                            }),
                                            value: OUTPUT_FORMATS.pdf,
                                        },
                                        {
                                            label: props.intl.formatMessage({
                                                id:
                                                    'containers.Reports.Generators.Driving.OutputFormat.Xls',
                                            }),
                                            value: OUTPUT_FORMATS.xls,
                                        },
                                    ]}
                                    value={format}
                                    borderColor={colors.grayED}
                                    arrowColor={colors.green63}
                                    onChange={onChangeSelect('format')}
                                />
                            </DrivingReportGenerator.SelectContainer>
                        </DrivingReportGenerator.ColumnRep>
                    </div>

                    <div>
                        <DrivingReportGenerator.ColumnRep>
                            <DrivingReportGenerator.ButtonContainer>
                                <DrivingReportGenerator.DateButton
                                    onClick={handleSetPeriod(PRESET_PERIODS.today)}
                                >
                                    <FormattedMessage
                                        id={'containers.Reports.Generators.Driving.Today'}
                                    />
                                </DrivingReportGenerator.DateButton>
                                <DrivingReportGenerator.DateButton
                                    onClick={handleSetPeriod(PRESET_PERIODS.yesterday)}
                                >
                                    <FormattedMessage
                                        id={'containers.Reports.Generators.Driving.Yesterday'}
                                    />
                                </DrivingReportGenerator.DateButton>
                                <DrivingReportGenerator.DateButton
                                    onClick={handleSetPeriod(PRESET_PERIODS.thisWeek)}
                                >
                                    <FormattedMessage
                                        id={'containers.Reports.Generators.Driving.ThisWeek'}
                                    />
                                </DrivingReportGenerator.DateButton>
                                <DrivingReportGenerator.DateButton
                                    onClick={handleSetPeriod(PRESET_PERIODS.lastWeek)}
                                >
                                    <FormattedMessage
                                        id={'containers.Reports.Generators.Driving.LastWeek'}
                                    />
                                </DrivingReportGenerator.DateButton>
                                <DrivingReportGenerator.DateButton
                                    onClick={handleSetPeriod(PRESET_PERIODS.thisMonth)}
                                >
                                    <FormattedMessage
                                        id={'containers.Reports.Generators.Driving.ThisMonth'}
                                    />
                                </DrivingReportGenerator.DateButton>
                                <DrivingReportGenerator.DateButton
                                    onClick={handleSetPeriod(PRESET_PERIODS.lastMonth)}
                                >
                                    <FormattedMessage
                                        id={'containers.Reports.Generators.Driving.LastMonth'}
                                    />
                                </DrivingReportGenerator.DateButton>
                                <DrivingReportGenerator.SubmitButton onClick={handleGenerateReport}>
                                    <FormattedMessage
                                        id={'containers.Reports.Generators.Driving.Generate'}
                                    />
                                </DrivingReportGenerator.SubmitButton>
                            </DrivingReportGenerator.ButtonContainer>
                        </DrivingReportGenerator.ColumnRep>
                    </div>
                </DrivingReportGenerator>
                <Split color={colors.splitGrayReports} opacity={0.2} />
                <InputLabel margin={'30px 0 20px 0'}>
                    <FormattedMessage id={'containers.Reports.Generators.Driving.Vehicles'} />
                </InputLabel>
                {props.errors.get('equipmentIds') && (
                    <DrivingReportGenerator.Error>
                        <Error
                            text={props.intl.formatMessage({
                                id: 'containers.Reports.Generators.Driving.EquipmentIdsError',
                            })}
                        />
                    </DrivingReportGenerator.Error>
                )}
                <ReportVehicleSearch
                    equipment={props.equipment.filter((eq) => {
                        if (eq.toJS().cardNumber) {
                            return !eq.toJS().cardNumber.startsWith('B');
                        } else {
                            return true;
                        }
                    })}
                    onCheckVehicles={handleOnCheckVehicles}
                    checkedInputs={equipmentIds}
                    onSelectAllVehicles={handleOnSelectAllVehicles}
                    onUnselectAllVehicles={handleOnUnselectAllVehicles}
                />
                <Split color={colors.splitGrayReports} opacity={0.2} />
            </div>
        );
    };
    const renderFooterAllVehiclesItem = () => {
        let columnSize = 8;
        const { report } = props;
        let totalAllMaintenanceNumber = 0;
        let totalAllMaintenanceCost = 0;
        let totalAllMaintenanceAverageCost = 0;

        report.forEach((data) => {
            if (data) {
                data.get('data').forEach((data) => {
                    totalAllMaintenanceNumber += 1;
                    if (parseFloat(data.get('Cout'))) {
                        totalAllMaintenanceCost += parseFloat(data.get('Cout'));
                    }
                });
            }
        });
        if (totalAllMaintenanceNumber > 0) {
            totalAllMaintenanceAverageCost = totalAllMaintenanceCost / totalAllMaintenanceNumber;
        }
        const getTableSize = report.size;
        if (getTableSize <= 1) {
            return;
        }
        return (
            <Alert
                style={{
                    color: colors.black,
                    backgroundColor: '#bfbfbf33',
                    borderColor: colors.green63,
                }}
            >
                <Dashboard.FooterContainer columns={columnSize}>
                    <Dashboard.FooterItem>
                        <Dashboard.FooterText>
                            <FormattedMessage id="containers.Reports.Generators.Maintenance.AllMaintenanceCount" />
                            : <br />
                            {totalAllMaintenanceNumber}
                        </Dashboard.FooterText>
                    </Dashboard.FooterItem>
                    <Dashboard.FooterItem>
                        <Dashboard.FooterText>
                            <FormattedMessage id="containers.Reports.Generators.Maintenance.AllMaintenanceCost" />
                            : <br />
                            {totalAllMaintenanceCost.toFixed(2)}
                        </Dashboard.FooterText>
                    </Dashboard.FooterItem>
                    <Dashboard.FooterItem>
                        <Dashboard.FooterText>
                            <FormattedMessage id="containers.Reports.Generators.Maintenance.AllMaintenanceAverageCost" />
                            : <br />
                            {totalAllMaintenanceAverageCost.toFixed(2)}
                        </Dashboard.FooterText>
                    </Dashboard.FooterItem>
                </Dashboard.FooterContainer>
            </Alert>
        );
    };
    const renderReport = () => {
        const reportTitle = props.intl.formatMessage({
            id: 'views.Maintenance.SideMenu.Report',
        });
        const { report } = props;

        const entries = [
            {
                key: 'Date',
                label: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.date',
                }),
                sortMethod: null,
            },
            {
                key: 'NumeroDeFacture',
                label: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.invoiceNumber',
                }),
                sortMethod: null,
            },
            {
                key: 'Cout',
                label: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.cost',
                }),
                sortMethod: null,
            },
            {
                key: 'TypeVehicule',
                label: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.vehicleTypes',
                }),
                sortMethod: null,
            },
            {
                key: 'DateEntree',
                label: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.entryDate',
                }),
                sortMethod: null,
            },
            {
                key: 'DateSortie',
                label: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.exitDate',
                }),
                sortMethod: null,
            },
            {
                key: 'technicianName',
                label: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.technician',
                }),
                sortMethod: null,
            },
            {
                key: 'TypeReparation',
                label: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.repairType',
                }),
                sortMethod: null,
            },
            {
                key: 'Departement',
                label: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.department',
                }),
                sortMethod: null,
            },
            {
                key: 'Garage',
                label: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.garage',
                }),
                sortMethod: null,
            },
            {
                key: 'Odometre',
                label: props.isImperial()
                    ? props.intl.formatMessage({
                          id: 'containers.Maintenance.VehicleDetails.Miles',
                      })
                    : props.intl.formatMessage({
                          id: 'containers.Maintenance.VehicleDetail.VehiculeOdometer',
                      }),
                sortMethod: null,
            },
            {
                key: 'Horometre',
                label: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.hourmeter',
                }),
                sortMethod: null,
            },
            {
                key: 'EntretienCommentaire',
                label: props.intl.formatMessage({
                    id: 'containers.Reports.Generators.Maintenance.comments',
                }),
                sortMethod: null,
            },
        ];

        const reportFilterText = [];

        reportFilterText.date = `${props.intl.formatMessage({
            id: 'containers.Reports.Generators.From',
        })} ${periodFrom} ${props.intl.formatMessage({
            id: 'containers.Reports.Generators.To',
        })} ${periodTo}`;

        const tables = [];
        report.forEach((data) => {
            if (data) {
                tables.push(
                    <ReportDataTable
                        title={data.get('vehiculeNumb')}
                        vehicleId={data.get('vehiculeId')}
                        columns={entries}
                        tableData={data.get('data')}
                        reportFilterText={reportFilterText}
                    />
                );
            }
            // getTableSize = tables.length;
        });

        if (props.loading) {
            if (props.loading) {
                return <Loader loading />;
            }
        }

        return (
            <Report.Header>
                <DrivingReportGenerator.ReportType style={{ marginTop: 15, marginBottom: 40 }}>
                    {!reportGeneratedFilterOpen && (
                        <React.Fragment>
                            <Report.TextContainer>
                                <Report.Icon
                                    src={ReportIcon}
                                    width={26}
                                    height={26}
                                    margin={'0 9px 0 0'}
                                />
                                {reportTitle}
                            </Report.TextContainer>
                            <Report.TextContainer>
                                <Report.Icon
                                    src={Calendar}
                                    width={26}
                                    height={26}
                                    margin={'0 9px 0 0'}
                                />
                                {reportFilterText.date}
                                <br />
                                {reportFilterText.time}
                            </Report.TextContainer>
                        </React.Fragment>
                    )}
                    <Report.ModifyReport onClick={handleOnClickModifyReport}>
                        <Report.Icon
                            src={MagnifyingGlass}
                            width={20}
                            height={20}
                            margin={'0 0 0 17px'}
                        />
                        <p style={{ marginTop: '0px', marginBottom: '0px' }}>
                            <FormattedMessage id={'containers.Reports.Generators.Modify'} />
                        </p>
                    </Report.ModifyReport>
                </DrivingReportGenerator.ReportType>
                <SlideDown className={'generator'}>
                    {reportGeneratedFilterOpen ? renderGenerator() : null}
                </SlideDown>
                {tables}
                {renderFooterAllVehiclesItem()}
            </Report.Header>
        );
    };
    return (
        <ReportGeneratorContainer>
            <GenerateReportHeader
                report={report}
                title={props.intl.formatMessage({
                    id: 'views.Maintenance.SideMenu.Report',
                })}
                onExportPDF={!reportGeneratedFilterOpen ? handleOnExportPDF : null}
                onExportXLS={!reportGeneratedFilterOpen ? handleOnExportXLS : null}
            />
            <Split color={colors.splitGrayReports} opacity={0.2} margin={'0 0 28px 0'} />
            {props.report && props.report.size > 0 ? renderReport() : renderGenerator()}
        </ReportGeneratorContainer>
    );
};

const mapStateToProps = createStructuredSelector({
    errors: selectMaintenanceReportGenerationErrors(),
    loading: selectIsLoading(),
    report: selectMaintenanceReport(),
    equipment: selectVehicles(),
    getCurrentUser: selectorsGetCurrentUser(),
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            validateMaintenanceReportGenerator,
            generateMaintenanceReport,
            removeMaintenanceReportError,
            resetMaintenanceReport,
            isImperial,
            thunksGetCurrentUser,
        },
        dispatch
    );

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(injectIntl(ReportPageComponent))
);
